import api from "./api";

export const getAllExams = () => {
  return api.get("/exams/all");
};

export const getCourseExams = (courseId) => {
  return api.get(`/exams/course/${courseId}`);
};

export const createExam = (courseId, data) => {
  return api.post(`/exams/course/${courseId}`, data);
};

export const submitExam = (examId, answers) => {
  return api.post(`/exams/${examId}/submit`, { answers });
};

export const updateExam = (examId, data) => {
  return api.put(`/exams/${examId}`, data);
};

export const deleteExam = (examId) => {
  return api.delete(`/exams/${examId}`);
};

export const getSubmission = (submissionId) => {
  return api.get(`/exams/submissions/${submissionId}`);
};

export const getMySubmissions = () => {
  return api.get('/exams/submissions/me');
};
